const messages = {
  [`main.count`]: "تعداد سفارش",
  [`flow`]: "نوع درخواست ها",
  [`notify`]: "اعلانات",
  [`sms`]: "پیامک ها",
   [`orders`]: "سفارشات",
  [`catalogs`]: "تعداد سفارش",
  [`catalog`]: "کاتالوگ",
  "admin.dashboard": "داشبورد ",
  province: "استان",
  city: "شهرستان",
  region: "منطقه",
  district: "محله",
  district: "محله",
  GeographicalRegion: "موقعیت جغرافیایی",
  "apply.filter": "اعمال فیلتر",
  description: "توضیحات",
  view: "مشاهده",
  cancel: "انصراف",
  chat: "چت سیستمی",
  close: "خروج",
};

export default messages;
